module.exports = __webpack_public_path__ + "static/media/facebook.b856d999.svg";